
import { Vue, Component } from "vue-property-decorator";
import PageLayout from "@/components/layout/PageLayout.vue";
import Status from "@/components/base/Status.vue";
import { namespace } from "vuex-class";
import { showServerError } from "@/utils";
import { getOneEmployeesOffer } from "@/api/offers";
import { OfferSingle } from "@/services/offers/OfferSingle";
import GoalMain from "@/components/offers/offer/goal/GoalMain.vue";
import { eventBus } from "@/eventbus";
import GoalPayoutAndRevenue from "@/components_v3/offers/offer/goal/GoalPayoutAndRevenue.vue";
import GoalTracking from "@/components/offers/offer/goal/GoalTracking.vue";
import { IOfferGoal } from "@/api/types/offers";

const auth = namespace('authModule');

@Component({
    beforeRouteEnter(to: any, from: any, next: (arg0?: (vm: any) => void) => void) {
        next(vm => {
            if (from.fullPath !== '/') {
                vm.beforeListRoute = from.fullPath;
            }
        });
    },
    components: { GoalTracking, GoalPayoutAndRevenue, GoalMain, Status, PageLayout },
})

export default class Goal extends Vue {
    @auth.Getter('GET_USER') user;
    beforeListRoute = '/offers/all';

    goalID: string = '';
    offerID: string = '';
    offer: OfferSingle | null = null;
    goal: IOfferGoal | null = null;
    loading: boolean = false;

    get getTitle(): string {
        return `Оффер ${this.offerID} / Цель ${this.goal ? this.goal.legacy_id : ''} ${this.goal ? this.goal.name : ''}`;
    }

    created(): void {
        this.goalID = this.$route.params.id;
        this.offerID = this.$route.query.offer_id.toString();
        eventBus.$on("update-goal", this.getOfferById);
        this.getOfferById();
    }

    async getOfferById(): Promise<void> {
        try {
            this.loading = true;
            const data = await getOneEmployeesOffer(this.offerID);
            this.offer = new OfferSingle(data);
            this.goal = this.offer.goals.find((item) => item.id === Number(this.goalID))!;
            document.title = this.getTitle;
        } catch (err) {
            showServerError(err, 'Не удалось получить оффер');
        } finally {
            this.loading = false;
        }
    }

    beforeDestroy(): void {
        eventBus.$off("update-goal", this.getOfferById);
    }

    backToList(): void {
        this.$router.push({ path: this.beforeListRoute });
    }
}
